/** @format */

import React, { createContext, useEffect, useMemo } from "react";

//components
import Tools from "../components/Bootcamp/Tools";
import Funding from "../components/Bootcamp/Funding";
import ClassesCarrousel from "../components/Bootcamp/ClassesCarrousel";
import Schedule from "../components/Bootcamp/Schedule";
import Testimonies from "../components/Bootcamp/Testimonies";
import ATypicalDay from "../components/Bootcamp/ATypicalDay";
import BenefitsTitle from "../components/Bootcamp/BenefitsTitle";
import CardsBenefits from "../components/Bootcamp/CardsBenefits";
import CourseModalityCards from "../components/Bootcamp/CourseModalityCards";
import { useLocation, useNavigate } from "react-router-dom";
import BootcampTitle from "../components/Bootcamp/BootcampTitle";
import BootcampText from "../components/Bootcamp/BootcampText";
import { useTheme } from "@mui/styles";
import { useCourses } from "../context/CourseContext";

export const ColorContext = createContext({
  colorTheme: null,
  mainColor: null,
  secondaryColor: null,
  iconColor: null,
});

const Bootcamp = () => {
  const { jsBootcampCourses, sfBootcampCourses } = useCourses();
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const theme = useTheme();
  const selectedBootcamp = pathname.split("/").at(-1);
  const colors = useMemo(
    () => ({
      javascript: {
        colorTheme: "yellow",
        mainColor: theme.palette.yellow.main,
        secondaryColor: theme.palette.yellow.secondary,
        iconColor: theme.palette.yellow.third,
      },
      salesforce: {
        colorTheme: "blue",
        mainColor: theme.palette.blue.ninth,
        secondaryColor: theme.palette.blue.tenth,
        iconColor: theme.palette.blue.lightblue,
      },
    }),
    [
      theme.palette.yellow.main,
      theme.palette.yellow.secondary,
      theme.palette.yellow.third,
      theme.palette.blue.ninth,
      theme.palette.blue.tenth,
      theme.palette.blue.lightblue,
    ]
  );

  useEffect(() => {
    if (!["salesforce", "javascript"].includes(selectedBootcamp)) {
      navigate("/404");
    }
  }, [selectedBootcamp, navigate]);

  return (
    <ColorContext.Provider
      value={colors[selectedBootcamp]}
      displayName="ColorContext"
    >
      <BootcampTitle />
      <BootcampText />
      <BenefitsTitle />
      <CardsBenefits />
      <CourseModalityCards />
      <ClassesCarrousel />
      <Tools />
      <Funding />
      <Schedule courses={selectedBootcamp === "salesforce" ? sfBootcampCourses : jsBootcampCourses}/>
      <ATypicalDay />
      <Testimonies />
    </ColorContext.Provider>
  );
};

export default Bootcamp;
